import {
  authenticationChannel,
  authenticationContext,
  sessionManagement,
  ActivityMonitor
} from '@codametrix/ui-common';

const { activityMonitor } = sessionManagement;


export const getServiceDeskClient = () => {

  //@ts-ignore
  const xcaliberClient = ServiceDesk.init({
    theme: {},
    bffURL: '/api/service-desk/bff',
    getBearerToken: async () => {
      await authenticationChannel.ready;
      const token = authenticationContext.getToken();
      if (!token) {
        // need to track occurrence of this error and alert on it
        throw new Error('No authentication token available for Service Desk');
      }
      //Check if token already has text Bearer, appened only if it not present
      if (token && token.indexOf('Bearer') !== -1) {
        return `${token}`;
      }
      return `Bearer ${token}`;
    }
  });

  activityMonitor.on(ActivityMonitor.events.DID_REFRESH, async () => {
    if (xcaliberClient) {
      xcaliberClient.refreshToken();
    }
  });
  
  return xcaliberClient;
};
